import VerificationDlg from '../../pages/VerificationDlg/VerificationDlg';
import LottieAlert from '../LottieAlert/LottieAlert';
import { InvoiceCreateForm } from './InvoiceCreateForm';
import OnboardingMessage from './OnboardingMessage';
import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useFormContext } from 'react-hook-form';
import { AccountStatus, TaskType } from '@admiin-com/ds-graphql';
import { WBLink } from '@admiin-com/ds-web';
import { PATHS } from '../../navigation/paths';
import { useTaskCreationContext } from '../../pages/TaskCreation';
import { needsVerificationCompletion } from '../../helpers/entities';
import { useDefaultValueForFromTo } from '../../features/providers/TaskCreationProvider/TaskCreationProvider';
import { useTaskCounts } from '../../features/hooks/useTaskCounts/useTaskCounts';
import useTaskSearchFilters from '../../features/hooks/useTaskSearchFilters/useTaskSearchFilters';

export const InvoiceCreateFormContainer = () => {
  const { t } = useTranslation();
  const { task, setTaskDirection } = useTaskCreationContext();
  const entity = useDefaultValueForFromTo();

  const { filters } = useTaskSearchFilters();
  const { counts } = useTaskCounts({
    entityId: entity?.id,
    ...filters,
  });
  const totalCount = counts?.ALL ?? 0;

  const { watch, setValue } = useFormContext();
  const { from } = watch();
  const [showVerify, setShowVerify] = useState<boolean>(false);

  const [isOnboarding, setIsOnboarding] = React.useState(true);

  React.useEffect(() => {
    if (totalCount === 0) {
      setIsOnboarding(true);
    } else setIsOnboarding(false);
  }, [totalCount]);

  React.useEffect(() => {
    if (task && task.status === 'DRAFT') setIsOnboarding(false);
  }, [task]);

  React.useEffect(() => {
    setTaskDirection('SENDING');
    setValue('type', TaskType.PAY_ONLY);
  }, [setTaskDirection, setValue]);

  return isOnboarding ? (
    <OnboardingMessage
      segment={[0, 30]}
      lottiePath={'/lottie/send-invoice.lottie'}
      onGetStarted={() => setIsOnboarding(false)}
      title={t('sendInvoiceTitle', { ns: 'taskbox' })}
      description={
        <>
          {t('sendInvoiceMessage1', { ns: 'taskbox' })}
          <WBLink
            href={PATHS.admiinAccount}
            target="_blank"
            color="primary.main"
          >
            {t('admiinAccount', { ns: 'taskbox' })}
          </WBLink>
          {t('sendInvoiceMessage2', { ns: 'taskbox' })}
        </>
      }
      buttonTitle={t('getStarted', { ns: 'taskbox' })}
    />
  ) : (
    <>
      {needsVerificationCompletion(from) ? (
        <VerificationDlg
          entity={from}
          onSuccess={() => {
            console.log('success');
          }}
          open={showVerify}
          onClose={() => setShowVerify(false)}
        />
      ) : null}
      {from &&
        from?.taxNumber &&
        from?.accountStatus !== AccountStatus.ACTIVE && (
          <LottieAlert
            lottiePath="/lottie/exclamation.lottie"
            title={t(`KYC${from.accountStatus}`, { ns: 'common' })}
            message={t(`INVOICE_QUOTE_${from?.accountStatus}_Description`, {
              ns: 'common',
            })}
            btnText={
              needsVerificationCompletion(from)
                ? t('completeVerification', { ns: 'common' })
                : undefined
            }
            onClick={
              needsVerificationCompletion(from)
                ? () => setShowVerify(true)
                : undefined
            }
            isIn={true}
          />
        )}
      <InvoiceCreateForm />
    </>
  );
};
